import { render, staticRenderFns } from "./BandejaEliminarSolicitudComponente.vue?vue&type=template&id=39874477&scoped=true"
import script from "./BandejaEliminarSolicitudComponente.vue?vue&type=script&lang=js"
export * from "./BandejaEliminarSolicitudComponente.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39874477",
  null
  
)

export default component.exports